module.exports = __webpack_public_path__ + "static/media/trip-2.d80975ef.png";